import React, { Fragment, useEffect } from "react";
import { withRouter } from "react-router-dom";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import {
  Box,
  IconButton,
  Stack,
  TableContainer,
  TextField,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableFooter from "@mui/material/TableFooter";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { makeStyles } from "@material-ui/core/styles";

import Autocomplete from "@mui/material/Autocomplete";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Typography from "@mui/material/Typography";
import { faEye, faFile } from "@fortawesome/free-solid-svg-icons";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { v4 as uuidv4 } from "uuid";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Collapse from '@mui/material/Collapse';
import {
  obtenerDatosPredioByIdCliente,
  obtenerDatosPredioByNoSocio,
} from "../../../redux/DucksUsuarioAgricola/DatosPredioDucks";
import { useDispatch, useSelector } from "react-redux";
import {
  datMagueyH,
  obtenerAllDatosMagueyHistorico,
} from "../../../redux/DucksUsuarioAgricola/DatosMagueyHistoricoDucks";

const InformacionPredio = (props) => {
    const dispatch = useDispatch();

    let dataPredio = useSelector((store) => store.DatosPredioApi.data.data);
    const  dataAsociado = useSelector((store) => store.InformacionValidaApi.data.data);

    const [guias, setGuias] = React.useState([]);
    const handleCloseGuia = () => setOpenG(false);
    const [openG, setOpenG] = React.useState(false);
    const [asociado, setAsociado] = React.useState({
      numerosocio: null,
      idcliente: null,
      personafisica: null,
      personamoral: null,
      nombrerazonsocial: null,
      fechasolicitud: null,
      rfc: null,
      telefono: null,
      correoelectronico: null,
      nombrerepresentantelegal: null,
      telefonorepresentante: null,
      correoelectronicorepresentante: null,
      empresacertificadora: null,
      idtipocliente: null,
      idlogin: null,
      idcartera: null,
    });
  
    const [dataMagueyH, setDataMagueyH] = React.useState({
      iddatosmaguey: null,
      numeroplantas: null,
      sistemaplantacion: null,
      distanciaplantas: null,
      distanciasurcos: null,
      edad: null,
      iddatospredio: null,
      idcatalogomaguey: null,
      usuariocambio: null,
      fechacreacion: null,
    });
  
    const [modal, setModal] = React.useState(false);
  
    const abrirCerrarModal = (item) => {
      setAsociado(item);
      setModal(!modal);
    };
  
    const boxDefault = {
      height: 100,
      boder: "1px solid black",
      padding: 2,
      minWidth: 550,
      m: 1,
    };
  
    const style = {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 800,
      bgcolor: "background.paper",
      border: "2px solid #000",
      boxShadow: 24,
      p: 4,
    };
  
    const handleOpenG = (guias) => {
      setGuias(guias);
      setOpenG(true);
    };
  
    const [noGuia, setNoGuia] = React.useState("");
  
    const dataValues = props.dataValues;
  
    const dataTableHead = props.dataTableHead;
    /*  */
    const [openModal, setOpenModal] = React.useState(false);
  
    const descriptionElementRef = React.useRef(null);
  
    const [openModalPredio, setOpenModalPredio] = React.useState(false);
  
    const descriptionElementPredioRef = React.useRef(null);
  
    const handleClickOpen = (item) => {
      setOpenModal(true);
      setAsociado(item);
    };
  
    const handleChangePanel = async (row) => {
     // await dispatch(obtenerAllDatosMagueyHistorico(row.iddatospredio));
     props.history.push("/PanelConsultaMovimiento", {
        iddatospredio: row.iddatospredio,nombrepredio:row.nombrepredio
      });
      
    };
  
    const handleClose = () => {
      setOpenModal(false);
    };
  
    const handleClickPredioOpen = (item) => {
      setOpenModalPredio(true);
      setPredio(item);
    };
  
    const handleAceptarPredio = () => {
      setOpenModalPredio(false);
    };
  
    const handleClosePredio = () => {
      setOpenModalPredio(false);
    };
  
    /*  */
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    const [search, setSearch] = React.useState("");
    const [dataTable, setDataTable] = React.useState(dataValues);
  
  
    const emptyRows =
      page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataTable.length) : 0;
  
    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };
  
    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
    };
  
    const filterValues = (valueSearch) => {
      const dataFilter = dataTable.filter((item) => {
        if (
          item.nombrerazonsocial
            .toString()
            .toLowerCase()
            .includes(valueSearch.toString().toLowerCase()) ||
          item.idcliente
            .toString()
            .toLowerCase()
            .includes(valueSearch.toString().toLowerCase()) ||
          item.numerosocio
            .toString()
            .toLowerCase()
            .includes(valueSearch.toString().toLowerCase())
        ) {
          return item;
        }
      });
      setDataTable(dataFilter);
    };
  
    React.useEffect(() => {
      if (!search.trim() || !search) {
        setDataTable(dataValues);
        return;
      }
  
      filterValues(search);
    }, [search]);
  
    React.useEffect(() => {
      // dispatch(obtenerRegistrosPredios());
    }, []);
  
    React.useEffect(() => {
      if (asociado.idcliente !== null) {
        dispatch(obtenerDatosPredioByIdCliente(asociado.idcliente));
      }
    }, [asociado]);
  
    const [predio, setPredio] = React.useState({
      id: null,
      num_guia: null,
      superficieH: null,
      nombre_predio: null,
      longitud: null,
      nombre_cliente: null,
      RFC: null,
      estado: null,
      representanteLegal: null,
      razonSocial: null,
      latitud: null,
      localidad: null,
      municipio: null,
      calle: null,
      noExt: null,
      cp: null,
      correo: null,
      edad: null,
      existencia: null,
    });
  
/*     const bodyPredio = (
      <>
        <div className="bg-light rounded  ">
          <h3 className="text-center">Maguey en Predio</h3>
          <div className="row">
            <div className="col-12 pt-4">
              <Paper sx={{ width: "100%" }}>
                <TableContainer sx={{ maxHeight: 1000 }}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Especie</TableCell>
                        <TableCell>No. Plantas Registradas </TableCell>
                        <TableCell>Existencia</TableCell>
                        <TableCell>Sistema Plantacion</TableCell>
                        <TableCell>Edad Registro</TableCell>
                        <TableCell>Edad Aumento Anual</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {predio !== null && predio.datosmaguey ? (
                        predio.datosmaguey.map((item, i) => (
                          <TableRow
                            key={item.id}
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },
                            }}
                          >
                            <TableCell>{item.catalogomaguey.nombrecomun+ '' + '-' + item.catalogomaguey.nombrecientifico}</TableCell>
                            <TableCell>{item.plantasregistradas}</TableCell>
                            <TableCell>{item.numeroplantas}</TableCell>
                            <TableCell>{item.sistemaplantacion}</TableCell>
                            <TableCell>{item.edad}</TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <></>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Paper>
            </div>
          </div>
        </div>
      </>
    ); */
    const body = (
      <>
        <div className="bg-light rounded  ">
          
            
            <div className="col-12 pt-4">
              <h4 className="text-center">Cliente: {asociado.nombrerazonsocial} <br/> <br/> No. Socio: {asociado.numerosocio} </h4>
              <Paper sx={{ width: "100%" }}>
                <TableContainer sx={{ maxHeight: 600 }}>
                  <Table>
                    <TableHead>
                      <TableRow>
                      <TableCell></TableCell>
                        <TableCell>No. Predio "A"</TableCell>
                        <TableCell>Nombre Predio</TableCell>
                        <TableCell>Estado</TableCell>
                        <TableCell>Municipio</TableCell>
                        <TableCell>Localidad</TableCell>
                        <TableCell>Opciones</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {dataPredio !== null ? (
                        dataPredio.map((item, i) => (
                         /*  <TableRow
                            key={item.id}
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },
                            }}
                          >
                            <TableCell>{item.iddatospredio}</TableCell>
                            <TableCell>{item.nombrepredio}</TableCell>
                            <TableCell>{item.estado}</TableCell>
                            <TableCell>{item.municipio}</TableCell>
                            <TableCell>{item.localidad}</TableCell>
  
                            <TableCell>
                              <button
                                type="button"
                                className="badge btn-primary text-warning btn-block"
                                onClick={() => handleClickPredioOpen(item)}
                              >
                                <FontAwesomeIcon icon={faEye} />
                                <br />
                                Ver
                              </button>
                              &nbsp;&nbsp;&nbsp;
                              <button
                                type="button"
                                className="badge btn-primary text-warning"
                                onClick={() => handleOpenG(item.guias)}
                              >
                                <FontAwesomeIcon icon={faFile} />
                                <br />
                                Guias
                              </button>
                            </TableCell>
                          </TableRow> */
                          <RowCollapse key={i} row={item} />
                        ))
                      ) : (
                        <></>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Paper>
  
          {/*     <Dialog
                open={openModalPredio}
                scroll="paper"
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
              >
                <DialogContent dividers={true}>
                  <DialogContentText
                    ref={descriptionElementPredioRef}
                    tabIndex={-1}
                  ></DialogContentText>
                  {bodyPredio}
                </DialogContent>
                <DialogActions>
                  <Stack
                    justifyContent="space-around"
                    alignItems="center"
                    component="span"
                    sx={boxDefault}
                  >
                    <Button onClick={handleChangePanel}>
                      {" "}
                      Ver Historial de Movimientos
                    </Button>
                    <Button onClick={handleClosePredio}>Cerrar</Button>
                  </Stack>
                </DialogActions>
              </Dialog> */}
  
              <div>
                <Modal
                  open={openG}
                  onClose={handleCloseGuia}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={style}>
                    <h4 variant="h6" component="h2" align="center">
                      Datos Guías
                    </h4>
                    <div className="col-12 pt-4">
                      <Paper sx={{ width: "100%" }}>
                        <TableContainer sx={{ maxHeight: 150 }}>
                          <Table>
                            <TableHead>
                              <TableRow>
                                <TableCell>Número de Guía</TableCell>
                                <TableCell>Fecha Creación</TableCell>
                                <TableCell>Status</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {guias !== null ? (
                                guias.map((item, i) => (
                                  <TableRow
                                    key={item.id}
                                    sx={{
                                      "&:last-child td, &:last-child th": {
                                        border: 0,
                                      },
                                    }}
                                  >
                                    <TableCell>{item.identificador}</TableCell>
                                    <TableCell>
                                      {item.fechacreacion
                                        ? new Date(item.fechacreacion)
                                            .toISOString()
                                            .split("T")[0]
                                        : "Sin registro"}
                                    </TableCell>
                                    <TableCell>
                                      {item.esactiva ? "Activa" : "No disponible"}
                                    </TableCell>
                                  </TableRow>
                                ))
                              ) : (
                                <></>
                              )}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Paper>
                    </div>
                    <Stack textAlign="center">
                      <Button onClick={handleCloseGuia}>Cerrar</Button>
                    </Stack>
                  </Box>
                </Modal>
              </div>
            </div>
          </div>
        
      </>
    );
  
    function RowCollapse(props) {
      const { row } = props;
      const [tableOpen, setTableOpen] = React.useState(false);

      return (
        <>
     <TableRow
      sx={{ "& > *": { borderBottom: "unset" } }}
    >
            <TableCell>
              <IconButton
                aria-label="expand row"
                size="small"
                onClick={() => {
                  if(tableOpen===false){
                    setPredio(row)
                  }
                  setTableOpen(!tableOpen)
                }}
              >
                {tableOpen ? (
                  <KeyboardArrowUpIcon />
                ) : (
                  <KeyboardArrowDownIcon />
                )}
              </IconButton>
            </TableCell>

            <TableCell >{row.iddatospredio}</TableCell>
            <TableCell>{row.nombrepredio}</TableCell>
            <TableCell>{row.estado}</TableCell>
            <TableCell>{row.municipio}</TableCell>
            <TableCell>{row.localidad}</TableCell>
            

            <TableCell >
              <div className="d-inline-flex"> 
              <button
                type="button"
                className=" p-1 m-1 badge btn-primary text-warning"
                onClick={()=>handleChangePanel(row)}
              >
                <FontAwesomeIcon icon={faEye} />
                <br />
                Historial
              </button>
          
              <button
                type="button"
                className="p-1 badge btn-primary text-warning "
                onClick={() => handleOpenG(row.guias)}
              >
                <FontAwesomeIcon icon={faFile} />
                <br />
                Guias
              </button>
              </div>
              
            </TableCell>
          </TableRow>
          {/*  */}
          <TableRow>
            <TableCell style={{ paddingBottom: .5, paddingTop: .5 }} colSpan={6}>
              <Collapse in={tableOpen} timeout="auto" unmountOnExit>
                <Box sx={{ marginBottom: 1 }}>
                  <Table size="small" >
                    <TableHead>
                      <TableRow>
                        <TableCell component="th" scope="row">Especie</TableCell>
                        <TableCell component="th" scope="row">No. Plantas Registradas </TableCell>
                        <TableCell component="th" scope="row">Existencia</TableCell>
                        <TableCell component="th" scope="row">Sistema Plantacion</TableCell>
                        <TableCell component="th" scope="row">Edad Registro</TableCell>
                        <TableCell component="th" scope="row">Edad Aumento Anual</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {predio !== null && predio.datosmaguey ? (
                        predio.datosmaguey.map((item, i) => (
                          <TableRow
                            key={item.id}
                            
                          >
                            <TableCell>{item.catalogomaguey.nombrecomun+ '' + '-' + item.catalogomaguey.catalogomagueynombrecientifico.nombrecientifico}</TableCell>
                            <TableCell>{item.numeroplantasregistro}</TableCell>
                            <TableCell>{item.numeroplantas}</TableCell>
                            <TableCell>{item.sistemaplantacion}</TableCell>
                            <TableCell>{item.edad}</TableCell>
                            <TableCell>{item.edad}</TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <></>
                      )}
                    </TableBody>
                  </Table>
                </Box>
              </Collapse>
            </TableCell>
          </TableRow>
        </>
      );
    }
  
    return (
      <Fragment>
        <br />
        <div className="container ">
          <div className="d-flex flex-row-reverse">
            <div className="p-6">
              <TextField
                id="a"
                value={search}
                label="Buscar"
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
                size="small"
              />
            </div>
          </div>
        </div>

        <div className="container ">
          <div className="row">
            <div className="col-12">
              <Paper sx={{ width: "100%" }}>
                <TableContainer sx={{ maxHeight: 600 }}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell></TableCell>
                        {dataTableHead.map((item, i) => (
                          <TableCell key={i}>{item}</TableCell>
                        ))}
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {(rowsPerPage > 0
                        ? dataTable.slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )
                        : dataTable
                      ).map((row, i) => (
                        <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
                          <TableCell></TableCell>
                          {/*<TableCell component="th" scope="row">
                            {row.idcliente}
                          </TableCell>*/}
                          <TableCell>{row.numerosocio}</TableCell>

                          <TableCell>
                            {row.nombrerazonsocial.toUpperCase()}
                          </TableCell>

                          <TableCell>
                            <button
                              type="button"
                              className="badge btn-primary text-warning"
                              onClick={() => handleClickOpen(row)}
                            >
                              <FontAwesomeIcon icon={faEye} />
                              <br />
                              Ver
                            </button>
                          </TableCell>
                        </TableRow>
                      ))}

                      {emptyRows > 0 && (
                        <TableRow style={{ height: 53 * emptyRows }}>
                          <TableCell colSpan={6} />
                        </TableRow>
                      )}
                    </TableBody>
                    <TableFooter>
                      <TableRow>
                        <TablePagination
                          rowsPerPageOptions={[
                            5,
                            10,
                            25,
                            { label: "Todos", value: -1 },
                          ]}
                          labelDisplayedRows={({ from, to, count }) =>
                            ` ${from}-${to} de ${count}`
                          }
                          labelRowsPerPage={<span>Registros por página:</span>}
                          count={dataTable.length}
                          rowsPerPage={rowsPerPage}
                          page={page}
                          onPageChange={handleChangePage}
                          onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                      </TableRow>
                    </TableFooter>
                  </Table>
                </TableContainer>
              </Paper>
              <Dialog open={openModal} scroll="body" maxWidth={"md"}>
                <DialogContent dividers={true}>
                  <DialogContentText
                    ref={descriptionElementRef}
                    tabIndex={-1}
                  ></DialogContentText>
                  {body}
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleClose}>Cerrar</Button>
                </DialogActions>
              </Dialog>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }  

export default  withRouter(InformacionPredio)